export default __webpack_public_path__ + "static/media/9.1374d585.jpg";